<script lang="ts">
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { onMount } from "svelte";
  import Summary from "@modern/components/retailer/reports/Summary.svelte";
  import Footer from "@modern/components/retailer/reports/Footer.svelte";
  import TopProducts from "@modern/components/retailer/reports/TopProducts.svelte";
  import Flash from "@shared/services/flashv2.js";
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import DatePicker from "@shared/svelte/Components/DatePicker.svelte";
  import moment from "moment";
  import * as _ from "lodash";
  import { getQueryParams } from "@modern/utils/queryparams";

  let loading = true;
  let reportsOverview;
  let reportsOverviewCategories;

  const queryParams = getQueryParams();
  let startDate =
    queryParams.get("startDate") || moment(new Date()).subtract(60, "days").format("YYYY-MM-DD");
  let endDate = queryParams.get("endDate") || moment(new Date()).format("YYYY-MM-DD");

  const fetchReportsOverview = async () => {
    if (!startDate || !endDate) return;

    try {
      reportsOverview = await HttpPromise({
        method: "GET",
        url: "/api/retailer/reports/overview",
        data: { start_date: startDate, end_date: endDate },
      });
    } catch (error) {
      Flash.now({
        message: "There was an error while fetching reports overview. Please contact support",
        type: "error",
      });
    }
  };

  const fetchReportsOverviewCategories = async () => {
    if (!startDate || !endDate) return;

    try {
      reportsOverviewCategories = await HttpPromise({
        method: "GET",
        url: "/api/retailer/reports/overview_categories",
        data: { start_date: startDate, end_date: endDate },
      });
    } catch (error) {
      Flash.now({
        message: "There was an error while fetching reports overview. Please contact support",
        type: "error",
      });
    }
  };

  const setParams = () => {
    const searchParams = getQueryParams();
    searchParams.set("startDate", startDate);
    searchParams.set("endDate", endDate);
    window.history.pushState(searchParams, "", `${window.location.pathname}?${searchParams}`);
  };

  const fetchReports = async () => {
    loading = true;
    await fetchReportsOverview();
    await fetchReportsOverviewCategories();
    setParams();
    loading = false;
  };

  onMount(() => {
    (async () => {
      await fetchReports();
    })();
  });

  $: noData = reportsOverview && _.sum(_.values(reportsOverview)) === 0;

</script>

<FizzStyles>
  <div class="fizz-surface">
    <div class="fizz-container fizz-inset-squish-16 fizz-stack-24">
      <h4 class="fizz-heading-4">Report Dashboard</h4>
    </div>
  </div>
  <div
    class="fizz-container fizz-surface fizz-stack-24 fizz-inset-squish-16 fizz-flex-row-responsive"
  >
    <DatePicker
      bind:startDate
      bind:endDate
      processDates={false}
      defaultButtonLabel="Date range"
      runFilters={fetchReports}
      alignmentOptions={{ desktop: { xPosition: "left" }, mobile: { xPosition: "left" } }}
      predefinedRanges={[30, 60, 90]}
    />
  </div>
  <div class="fizz-container fizz-stack-24">
    {#if loading}
      <div class="fizz-flex-row fizz-justify-center">
        <div class="fizz-icon-spinner" />
      </div>
    {:else if noData}
      <div class="fizz-text-center">
        <p>No data found for the dates selected.</p>
      </div>
    {:else if reportsOverview && reportsOverviewCategories}
      <section class="fizz-flex-row-responsive fizz-align-content-start">
        <Summary
          bind:reportsOverview
          bind:reportsOverviewCategories
          linkHref={`/reports/orders?startDate=${startDate}&endDate=${endDate}`}
        />
        <TopProducts
          {startDate}
          {endDate}
          linkHref={`/reports/products?startDate=${startDate}&endDate=${endDate}`}
        />
      </section>
    {/if}
  </div>
  <Footer />
</FizzStyles>
